<template>
<div class="chapter">
<div class="inner_page">
<h1 class="h1"><a id="page_i"></a>the goodbye season<a id="page_ii"></a></h1>
<p class="noindent"> </p>
<p class="noindent"> </p>
<p class="noindent"> </p>
<p class="center1"><img alt="Images" src="images/f000i-01.jpg"/></p>
<p class="author"><a id="page_iii"></a><span class="small"><strong>MARIAN HALE</strong></span></p>
<p class="publisher"><span class="small">HENRY HOLT AND COMPANY</span><br/><span class="small">NEW YORK</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// title.vue?73466de5